import Component from "../abstracts/Component";
import {replacePageInHistory} from "../utils/BrowserHistoryUtils";
import {CustomEvents} from "../utils/CustomEvents";

export default class HistoryManagerComponent extends Component {

  get SELECTORS() {
    return {
      pagersContainer: '.js-item-pagination'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {
    const {pagersContainer} = this.SELECTORS;
    this.$on(CustomEvents.FILTERS_EVENTS.updated, function (e) {
      const pageSupportsPagination = $(pagersContainer).length > 0;
      const {query,additionalData} = e.payload || {};
      if(query && query.trim().length > 0) {
        replacePageInHistory(query.replace(/\s.*/, ""), additionalData, '', !pageSupportsPagination && query.includes("page="));
      }
    });

    $(document).on('click', '.product-card[data-product-id]', function (e) {
      const currentProduct = $(this);
      const productId = currentProduct.data("product-id");
      const productPage = currentProduct.data("product-page");
      const href = $(currentProduct).find(".js-product-card").attr("href");
      if(productId && href) {
        let query = location.origin + location.pathname;
        const params = location.search;
        if(params.length != 0) {
          const paramPage = params.match(/page?=/);
          const paramPageVal = params.match(/page?=\d+/);
          if(paramPage != null && paramPageVal != null) {
            const OldParam = paramPageVal.toString();
            const newParam = paramPage.toString() + productPage;
            query+= params.replace(OldParam, newParam);
          } else {
            query+= params;
          }
        }
        const pageSupportsPagination = $(pagersContainer).length > 0;
        if(!pageSupportsPagination && !query.match(/[\?&]preload=/) && query.match(/[\?&]page=\d+/)) {
          query+="&preload=true";
        }
        replacePageInHistory(
          query,
          {
            focusElement: ".product-card[data-product-id=" + productId + "]"
          },
          '',
          !pageSupportsPagination && query.includes('page=')
        );
      }
    })
  }

  render() {
    this.bindEvents();
    console.info("[HistoryManager] init");
  }
}
